import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import CustomButton from '../../CustomButton'
import { Trans, useTranslation } from 'react-i18next'

const sectionComponents = { ul: <ul />, li: <li />, a: <a />, br: <br />, strong: <strong /> };

const SMSAgreementModal = (props) => {
    const { t } = useTranslation('translation', { keyPrefix: 'accountPage.accountNotificationsContainer.notificationsModal.SMSAgreementModal' });
    const { hideSMSAgreementModal, agreeToSMS } = props;
    const rawSections = t('sections', { returnObjects: true });
    const sections = Array.isArray(rawSections) ? rawSections : [];

    return (
        <Modal
            show={true}
            onHide={hideSMSAgreementModal}
            className="notifications-modal modal-lg-size"
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-lg">{t('titleSMSAgreement')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='agreement-modal-header'>
                    <img src='/images/rosco-logo-horizontal.png' />
                    <p>
                        {t('textMobileMessage')}
                    </p>
                    <p>
                        {t('effectiveDate')}
                    </p>
                </div>
                <div className='agreement-modal-body'>
                    {sections.map((section, index) => (
                        <div className='agreement-section' key={index}>
                            <h5>{section.heading}</h5>
                            <div className='agreement-section-body'>
                                <Trans components={sectionComponents}>{section.body}</Trans>
                            </div>
                        </div>
                    ))}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <CustomButton variant="delete" onClick={hideSMSAgreementModal}>{t('btnDisagree')}</CustomButton>
                <CustomButton variant="primary" onClick={agreeToSMS}>{t('btnAgree')}</CustomButton>
            </Modal.Footer>
        </Modal>
    )
}

export default SMSAgreementModal;
